import { paymentTermConstants } from "../../constants";

export function paymentTerms(state = {}, action) {
  switch (action.type) {
    // get all
    case paymentTermConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case paymentTermConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case paymentTermConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case paymentTermConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case paymentTermConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case paymentTermConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case paymentTermConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case paymentTermConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case paymentTermConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case paymentTermConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case paymentTermConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case paymentTermConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case paymentTermConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
